import { render } from "./DeleteTemplateModal.vue?vue&type=template&id=1eb4f116&scoped=true"
import script from "./DeleteTemplateModal.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateModal.vue?vue&type=script&lang=js"

import "./DeleteTemplateModal.vue?vue&type=style&index=0&id=1eb4f116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb4f116"]])

export default __exports__